import { useMemo } from "react";

import Valkyrie, { viXmark } from "@sippy-platform/valkyrie";

import { Box, CardContent, IconButton, LinearProgress, Typography } from "@mui/material";
import PropTypes from "prop-types";

export default function UploadStatus({ file, progress, controller, error, setFileTasks }) {
  const uploadProgress = useMemo(() => {
    return progress?.progress ?? 0;
  }, [progress?.progress]);

  const message = useMemo(() => {
    if (error) {
      if (error === "has already been taken") {
        return "A file with this name already exists";
      } else {
        return error;
      }
    } else if (!uploadProgress) {
      return "Getting ready...";
    } else if (uploadProgress === 1) {
      return "Finishing up...";
    } else {
      return `${Math.round(uploadProgress * 100)}%`;
    }
  }, [error, uploadProgress]);

  return (
    <CardContent
      sx={{ paddingBlock: "8px !important", borderTop: (theme) => `1px solid ${theme.vars.palette.divider}` }}
    >
      <Box sx={{ display: "flex", width: "100%", gap: 1 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            flexGrow: 1,
          }}
        >
          <Box sx={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Typography sx={{ fontSize: 14 }}>{error ? `${file?.name} couldn't be uploaded.` : file?.name}</Typography>
            <Typography sx={{ fontSize: 14 }}>{message}</Typography>
          </Box>
          <Box sx={{ width: "100%", mt: 0.5 }}>
            <LinearProgress
              variant={uploadProgress !== 1 || !!error ? "determinate" : "indeterminate"}
              color={error ? "error" : "primary"}
              value={uploadProgress !== 1 || !!error ? uploadProgress * 100 : 0}
            />
          </Box>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "ceter" }}>
          <IconButton
            disabled={uploadProgress === 1 && !error}
            onClick={() => {
              if (error) {
                setFileTasks((tasks) => tasks.filter((task) => task.file.name !== file.name));
              }

              controller.abort();
            }}
            size="small"
          >
            <Valkyrie icon={viXmark} />
          </IconButton>
        </Box>
      </Box>
    </CardContent>
  );
}

UploadStatus.propTypes = {
  file: PropTypes.object,
  progress: PropTypes.object,
  controller: PropTypes.object,
  setFileTasks: PropTypes.func,
  error: PropTypes.oneOf([PropTypes.string, false]),
};
